<template>
    <header role="banner">
        <div class="phone_bg" @click="phone_menu = false" v-if="phone_menu">

        </div>
        <div id="header" @click="phone_menu = false">
            <div class="container">
                <div class="row">
                    <div class="one-half column">
                        <router-link to="/">
                            <div id="logo">
                                <img src="../assets/swbase_logo.png" alt="SwBase Systems BV" width="492" height="163"/>
                            </div>
                        </router-link>
                    </div>
                    <span class="menu_bars fake_link small_screen" @click.stop="toggle_phone_menu">
                        <font-awesome-icon :icon="['fa', 'bars']" fixed-width/>
                    </span>
                    <div class="one-half column big_screen">
                        <nav role="navigation">
                            <ul>
                                <li>
                                    <router-link class="menu-item" to="/services">
                                        Diensten
                                    </router-link>
                                </li>
                                <li>
                                    <router-link class="menu-item" to="/about">
                                        Over ons
                                    </router-link>
                                </li>
                                <li>
                                    <router-link class="menu-item" to="/contact">
                                        Contact
                                    </router-link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <div class="container small_screen phone_menu" v-if="phone_menu" @click.prevent="">
                <div class="row">
                    <div class="column">
                        <nav role="navigation">
                            <ul>
                                <li @click="phone_menu = false">
                                    <router-link class="menu-item" to="/services">
                                        Diensten
                                    </router-link>
                                </li>
                                <li @click="phone_menu = false">
                                    <router-link class="menu-item" to="/about">
                                        Over ons
                                    </router-link>
                                </li>
                                <li @click="phone_menu = false">
                                    <router-link class="menu-item" to="/contact">
                                        Contact
                                    </router-link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faBars} from '@fortawesome/free-solid-svg-icons';

    library.add(faBars);

    export default {
        data() {
            return {
                phone_menu: false,
            }
        },
        methods: {
            toggle_phone_menu() {
                const self = this;
                self.phone_menu = !self.phone_menu;
            }
        }
    }
</script>

<style scoped>
    header {
        height: 100px;
        z-index: 100;
    }

    #header {
        height: 100px;
        width: 100%;
        z-index: 100;
        background-color: white;
        border-bottom: 1px solid #ddd;
        position: fixed;
    }

    #logo {
        max-height: 100px;
        margin: 15px 0;
        display: inline-block;
    }

    #logo img {
        max-height: 70px;
        width: auto;
    }

    nav {
        float: right;
    }

    .phone_menu nav {
        float: initial;
        border-bottom: 1px solid #ddd;
    }

    nav ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    nav ul li {
        display: inline-block;
        height: 84px;
        line-height: 84px;
    }

    .phone_menu nav ul li {
        display: block;
        line-height: initial;
        height: initial;
        background-color: white;
        color: black;
        margin: 0;
        text-align: center;
    }

    nav ul li .menu-item {
        display: block;
        padding: 8px 16px;
        color: #B9B9B9;
        text-decoration: none;
    }

    nav ul li .menu-item:hover,
    nav ul li .menu-item.router-link-active {
        color: #47A8E6;
    }

    .menu_bars {
        font-size: 24px;
        line-height: 100px;
        float: right;
        padding-left: 50px;
        padding-right: 50px;
        position: absolute;
        top: 0;
        right: 0;
    }

    .phone_menu {
        position: relative;
        top: -30px;
    }

    .phone_bg {
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
